import {
  CommunicationSizeComponent,
  ComponentIds,
  GuestConnectionsComponent
} from '@inter-ikea-core/core';
import { CoreApi, Product, ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';

export const hideDoorsFromSelectedFramesMenu = (coreApi: CoreApi) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) return true;
  const isExtension = coreApi.entities.isProductType(
    selectedEntity,
    ProductType.BILLY_FRAME_EXTENSION
  );
  const parent = coreApi.entities.getAncestorsWithProductType(
    selectedEntity,
    ProductType.BILLY_FRAME_WITH_SHELVES_ASM
  )?.[0];
  const entity = isExtension ? parent : selectedEntity;
  const isCorner =
    entity?.getComponent<GuestConnectionsComponent>(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)
      ?.highestPriorityConnection?.guestConnector.key === 'wall-corner';

  return isCorner;
};

export const hideDoorDirectionFromDoorsSelectedMenu = (coreApi: CoreApi) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  const parent = selectedEntity && coreApi.entities.getParent(selectedEntity);

  const frameWidth = parent?.getComponent<CommunicationSizeComponent>(
    ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
  )?.size?.width;

  // Only show direction filter for 400 width frames
  return frameWidth !== 400;
};

export const hideDepthToggleFromFramesMainMenu = (coreApi: CoreApi, products: Product[]) => {
  const depths = Array.from(
    new Set(
      products
        .filter(
          p =>
            p.type === ProductType.BILLY_FRAME ||
            p.type === ProductType.BILLY_FRAME_WITH_SHELVES_ASM
        )
        .map(p => p.communicatedDimensions.depth)
    )
  );
  return depths?.length <= 1;
};

export const hideToggleDeskType = (coreApi: CoreApi) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  const type = selectedEntity?.getComponent<ProductInfoComponent>(ProductInfoComponent.id)
    ?.productType;

  return type !== ProductType.BILLY_DESK;
};
